<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card hover>
        <v-card-title>Nueva cuenta</v-card-title>
        <v-card-text>
          <v-text-field type="text" ploceholder="Hola" v-model="email" />
          <v-text-field type="password" placeholder="Contraseña" v-model="password" />
          <br />
          <v-text-field type="password" placeholder="Firma" v-model="sign" />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$router.replace('login')">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="signUp">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import firebase from "firebase";

export default {
  name: "signUp",
  data() {
    return {
      db: firebase.firestore(),
      email: "",
      password: "",
      sign: ""
    };
  },
  methods: {
    signUp: function() {
      this.db
        .collection("config")
        .get()
        .then(refs => {
          if (refs.docs[0].data().firma === this.sign) {
            firebase
              .auth()
              .createUserWithEmailAndPassword(this.email, this.password)
              .then(user => {
                console.log("Usuario creado.");
                this.$router.replace("home");
              })
              .catch(error => {
                this.email = "";
                this.password = "";
                this.sign = "";
                console.log("Ops: " + error.message);
              });
          } else {
            this.sign = "";
            console.log("La firma no es correcta");
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>